export async function registerUsers(fullName, email, password) {

    const API_URL = process.env.REACT_APP_API_URL;
    if (!fullName || !email || !password) {
        throw new Error('All fields are required');
    }

    const response = await fetch(`${API_URL}/api/v1/register`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({"name":fullName, "email":email, "password":password})
    })

    return response;
}